<app-column label="Paint" [loading]="!interactive">
  <!-- Actions -->
  <div column-actions>
    <button
      app-button
      [matMenuTriggerFor]="paintMenu"
      class="context__actions">
      <fa-icon icon="ellipsis-v"></fa-icon>
    </button>

    <mat-menu #paintMenu="matMenu">
      <button mat-menu-item (click)="handleClearChapterPaint()">Clear this chapter's paint</button>
    </mat-menu>
  </div>

  <!-- Presets -->
  <app-column-group label="Presets">
    <ng-container column-group-body>
      <div class="pt-2 ph-3">
        <app-paint-presets></app-paint-presets>
      </div>
    </ng-container>
  </app-column-group>

  <!-- Custom -->
  <app-column-group label="Custom">
    <ng-container column-group-body>
      <div class="p-3">
        <app-paint-widget></app-paint-widget>
      </div>
    </ng-container>
  </app-column-group>

  <!-- Footer -->
  <div column-footer *ngIf="(checkedNodes$ | async)?.length">
    <div class="ph-4 pb-4">
      <app-selected-nodes-panel></app-selected-nodes-panel>
      <button class="w-100 mt-2" buttonType="outline" app-button (click)="handlePaintNodesClick()">Apply Paint</button>
    </div>
  </div>
</app-column>
